export default {
  container: {
    marginTop: 2,
    borderRadius: 2,
    overflow: 'hidden',
    width: '100%'
  },

  title: {
    fontSize: '20px',
    fontWeight: 600,
    marginBottom: 2
  },

  warningBox: {
    marginBottom: 2,
    backgroundColor: 'warning.light',
    color: 'warning.contrastText'
  },

  warningText: {
    fontSize: '14px'
  },

  sectionTitle: {
    marginBottom: 2
  },

  datePickerBox: (hasError: boolean) => ({
    padding: '12px',
    border: `1px solid ${hasError ? '#d32f2f' : '#e0e0e0'}`,
    borderRadius: '4px',
    cursor: 'pointer',
    '&:hover': {
      borderColor: hasError ? '#d32f2f' : '#bdbdbd'
    }
  }),

  datePickerText: (hasSelection: boolean) => ({
    color: hasSelection ? 'inherit' : '#666'
  }),

  errorText: {
    color: '#d32f2f',
    fontSize: '0.75rem',
    marginTop: '4px'
  },

  flightDateInfo: {
    fontSize: '0.875rem',
    color: '#666',
    marginTop: '8px'
  }
}
